export default __webpack_public_path__ + "886af08c5e57e2b1ac28e4a96e5f798d.svg";